// extracted by mini-css-extract-plugin
export default {"BlockedSectionMessage":"BlockedSection-module__BlockedSectionMessage--fXzjI"};